import ProfileTopNavigation from "./ProfileTopNavigation";
import AboutUsSection from "../../PageComponent/ProfilePage/AboutUsSection";

function AboutUs() {
  return (
    <div className="text-coalBlack">
      <ProfileTopNavigation pageTitle={"About Us"} />
      <AboutUsSection />
    </div>
  );
}

export default AboutUs;
